import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Routes from "../../routes";
import {
  DateInput,
  Select,
  CommonModal,
  PrimaryButton,
  ShutdownWarningModal,
} from "../Common";
import { trakrefFontFamily, } from "../../utils";
import toast from "react-hot-toast";

export const DeactivateLocation = ({
  id,
  open,
  close,
  saveCallback,
}) => {
  const [deactivateDate, setDeactivateDate] = useState(null);
  const [deactivateDateError, SetDeactivateDateError] = useState(null);
  const [reason, SetReason] = useState(null);
  const [reasonError, SetReasonError] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const [conflictCount, setConflictCount] = useState(0);

  const DeactivateLocation = async (e) => {
    e.stopPropagation();

    let errorExists = false;

    if (reason == null || reason == "") {
      SetReasonError("This field is required");
      errorExists = true;
    } else {
      SetReasonError(null);
    }
    if (deactivateDate == null || deactivateDate == "") {
      SetDeactivateDateError("This field is required");
      errorExists = true;
    } else {
      SetDeactivateDateError(null);
    }

    if (errorExists) return null;

    await performDeactivation(false);
  };

  const performDeactivation = async (ignoreConflicts) => {
    const requestData = {
      id,
      operationEndDate: deactivateDate,
      deactivateCoolingApplianceStatusId: reason,
      ignoreConflicts,
    };

    try {
      const response = await fetch(Routes.Location.DeactivateLocation(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : {};

        if (data.conflictingAssetCount > 0) {
          setConflictCount(data.conflictingAssetCount);
          setShowWarning(true);
          return;
        }

        toast.success("The location has been successfully deactivated.", { duration: 6000 });
        saveCallback();
      } else {
        toast.error("There was an error deactivating the location", { duration: 6000 });
      }
    } catch (error) {
      toast.error("There was an error deactivating the location", { duration: 6000 });
      console.error(error);
    }
  };

  const handleWarningComplete = async () => {
    setShowWarning(false);
    await performDeactivation(true);
  };

  const handleWarningCancel = () => {
    setShowWarning(false);
  };

  return (
    <>
      <CommonModal
        open={open}
        close={close()}
      >
        <Grid container width={499}>
          <Grid item xs={12} lg={12} mb={2} pt={2} align="center">
            <Typography
              sx={{
                padding: "1% 0%",
                fontSize: 22,
                fontWeight: 400,
                color: "#1A173B",
                fontFamily: trakrefFontFamily,
              }}
            >
              Deactivate Location
            </Typography>
          </Grid>

          <Grid item xs={12} align="center" mb={2} mr={8} ml={8}>
            <DateInput
              fullWidth
              label="Deactivate Date *"
              allowPast={true}
              allowFuture={true}
              date={deactivateDate}
              onChange={(e) => setDeactivateDate(e)}
              error={deactivateDateError}
            />

          </Grid>
          <Grid item xs={12} align="center" mb={5} mr={8} ml={8} >
            <Select
              fullWidth
              options={[
                { id: 10, name: "Destroyed or Disposed" },
              { id: 15, name: "Returned to Landlord" },
              { id: 11, name: "Sold" },
              ]}
              label="Reason *"
              onChange={(e) => SetReason(e.target.value)}
              value={reason}
              property="id"
              display="name"
              error={reasonError}
            />
          </Grid>
          <Grid item xs={12} align="center" marginBottom={2}>
            <PrimaryButton
              useLargeButton
              buttonText={"Deactivate Location"}
              onClick={DeactivateLocation}
              width={75}
            />
          </Grid>
        </Grid>
      </CommonModal>

      <ShutdownWarningModal
        open={showWarning}
        title="Shutdown Date Conflict"
        description={`${conflictCount} system${conflictCount !== 1 ? 's' : ''} have shutdown dates after the Deactivate Date. Complete to proceed, or Edit Date to go back.`}
        confirmButtonText="Complete"
        cancelButtonText="Edit Date"
        onConfirm={handleWarningComplete}
        onCancel={handleWarningCancel}
      />
    </>
  );
}

export default DeactivateLocation;
